import React from "react";
import { v4 as uuidv4 } from "uuid";
import { t } from "i18next";
import { useSelector, useDispatch } from "react-redux";

import { ButtonComp } from "components";
import { EXPLORE_MORE_OPTION, INITIAL_REPLY_OPTIONS, formatMessageEdit } from "utils";
import { getEnabledScheduleTour, getFilterOptions, setShowAllOptions } from "slices";
import { getShowFaq } from "slices/property-slice/index";

const ExtraOption = ({ from, buttons, extraButtons }) => {
  const enabledScheduleTour = useSelector(getEnabledScheduleTour);
  const filterOptions = useSelector(getFilterOptions);
  const isShowAMA = useSelector(getShowFaq);
  const dispatch = useDispatch();

  const reply = INITIAL_REPLY_OPTIONS?.filter((v) => ["find_home", "schedule_tour"].includes(v.key));

  let options = ["find_home"].includes(from) ? [EXPLORE_MORE_OPTION] : [...reply, EXPLORE_MORE_OPTION];

  if (!enabledScheduleTour) {
    options = options.filter((o) => o.nextOptionsType !== "ScheduleTour");
  }

  return (
    <div className="hayley-mt-4 hayley-flex hayley-flex-wrap">
      {buttons?.length
        ? buttons.map(({ text, handleClick }, i) => {
            return <ButtonComp testId={text} key={i} label={text} onClick={handleClick} className="hayley-mb-2 hayley-mr-2" />;
          })
        : null}
      {options
        .filter((v) => !filterOptions?.includes(v?.key))
        .map(({ content, nextOptionsType }) => {
          const label = content?.componentOptions?.label || "exploreMore";

          return (
            <ButtonComp
              key={uuidv4()}
              className={`hayley-mb-2 hayley-mr-2`}
              rounded={true}
              label={t(label)}
              testId={`${from}_${label}`}
              onClick={(e) => {
                if (label == "exploreMore" && isShowAMA) {
                  e.stopPropagation();

                  dispatch(setShowAllOptions(true));
                } else {
                  formatMessageEdit(nextOptionsType, label, from);
                }
              }}
              icon={content?.componentOptions?.icon || ""}
            />
          );
        })}
      {extraButtons?.length ? (
        <>
          <div className="hayley-mr-2 hayley-h-9 hayley-w-[1px] hayley-bg-secondary hayley-bg-opacity-20" />
          {extraButtons.map(({ text, handleClick }, i) => {
            return (
              <ButtonComp
                key={i}
                testId={`${from}_${text}`}
                label={text}
                onClick={handleClick}
                className="hayley-mb-2 hayley-mr-2"
                icon="OpenLinkIcon"
                isLeftIcon={false}
              />
            );
          })}
        </>
      ) : null}
    </div>
  );
};

export default ExtraOption;
